/**
 * Utilidades compartidas del módulo de conteos de inventario.
 */
import { tienePermisosModulo, puedeAccionPrograma } from "lib/seguridad/permisosPorModulo";

export const norm = (v) =>
  String(v ?? "")
    .trim()
    .toUpperCase();

/** Etiqueta humana del alcance de un conteo. */
export function alcanceLabel(conteo) {
  const alc = conteo?.alcance || "T";
  const marca = String(conteo?.marca || "").trim();
  if (alc === "M") return `Marca ${marca}`;
  if (alc === "D") return `Modelo ${[marca, String(conteo?.modelo || "").trim()].filter(Boolean).join(" ")}`;
  return "Toda la sucursal";
}

/**
 * Permisos del módulo, con el mismo criterio que permisos.py: las acciones
 * (cerrar = modificar, descartar = borrar) se exigen solo en el programa
 * nuevo "conteos"; un rol que solo tiene la fila vieja
 * "conteoinventariosucursal" conserva el comportamiento anterior (podía
 * cerrar y descartar) hasta que se siembre el programa nuevo en su tenant.
 */
export function puedeConteos(roleDetalles, accion) {
  if (tienePermisosModulo(roleDetalles, "conteos")) {
    return puedeAccionPrograma(roleDetalles, "conteos", accion);
  }
  return tienePermisosModulo(roleDetalles, "conteoinventariosucursal");
}

/**
 * Identificador estable del dispositivo (tablet/celular) para auditoría de
 * quién escaneó desde dónde. Se genera una vez y se guarda en localStorage.
 */
export function idDispositivo() {
  let d = localStorage.getItem("conteos_dispositivo");
  if (!d) {
    d = `web-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("conteos_dispositivo", d);
  }
  return d;
}
